import { motion } from 'motion/react';
import { useTranslation } from 'react-i18next';

import { BopsLogo } from '@Assets';

interface FloatingButtonProps {
  onClick: () => void;
  isVisible: boolean;
  isPulsing?: boolean;
}

const FloatingButton = ({ onClick, isVisible, isPulsing = false }: FloatingButtonProps) => {
  const { t } = useTranslation();
  if (!isVisible) return null;

  return (
    <div className="fixed bottom-8 right-8 z-[200]">
      {isPulsing && (
        <motion.div
          aria-hidden
          className="pointer-events-none absolute inset-0 rounded-full"
          style={{ backgroundColor: 'rgba(124, 108, 246, 0.3)' }}
          animate={{ scale: [1, 1.6, 1], opacity: [0.5, 0, 0.5] }}
          transition={{ duration: 1.8, repeat: Infinity, ease: 'easeInOut' }}
        />
      )}
      <button
        type="button"
        onClick={onClick}
        aria-label={t('Agent.AriaOpenAgent')}
        className="group relative flex h-14 w-14 cursor-pointer items-center justify-center rounded-full border border-gray-100 bg-white p-1 text-gray-900 shadow-lg outline-none transition-all duration-200 hover:scale-105 hover:text-gray-700 hover:shadow-xl focus:outline-none">
        <BopsLogo width={28} height={28} aria-hidden className="drop-shadow-sm" />
        <span className="pointer-events-none absolute bottom-full mb-3 rounded-lg bg-white px-3 py-1.5 text-xs opacity-0 shadow-sm transition-opacity duration-200 group-hover:opacity-100">
          OSA Agent
        </span>
      </button>
    </div>
  );
};

export default FloatingButton;
